export const ANALYZE_AUDIO = 'ANALYZE_AUDIO';
export const ANALYZE_AUDIO_SUCCESS = 'ANALYZE_AUDIO_SUCCESS';
export const ANSWER_QUESTION = 'ANSWER_QUESTION';
export const GO_TO_ITEM = 'GO_TO_ITEM';
export const GO_TO_NEXT_ITEM = 'GO_TO_NEXT_ITEM';
export const GO_TO_PREVIOUS_ITEM = 'GO_TO_PREVIOUS_ITEM';
export const HIDE_FEEDBACK = 'HIDE_FEEDBACK';
export const HIDE_RESULTS = 'HIDE_RESULTS';
export const MARK_ITEM_WITH_AUDIO = 'MARK_ITEM_WITH_AUDIO';
export const PROCESS_ITEMS = 'PROCESS_ITEMS';
export const RECOVER_SAVED_STATE = 'RECOVER_SAVED_STATE';
export const RESTART_EXERCISE = 'RESTART_EXERCISE';
export const SET_AUDIO_ENABLED = 'SET_AUDIO_ENABLED';
export const SET_AUDIO_PREFIX = 'SET_AUDIO_PREFIX';
export const SET_AUTO_NUM = 'SET_AUTO_NUM';
export const SET_BASE_PATH = 'SET_BASE_PATH';
export const SET_CORRECT_ANSWER = 'SET_CORRECT_ANSWER';
export const SET_EX_CONTAINER = 'SET_EX_CONTAINER';
export const SET_EXERCISE_READY = 'SET_EXERCISE_READY';
export const SET_INTERACTION = 'SET_INTERACTION';
export const SET_ITEM_MARKED_TEXT = 'SET_ITEM_MARKED_TEXT';
export const SET_ITEMS = 'SET_ITEMS';
export const SET_ITEMS_AAXML = 'SET_ITEMS_AAXML';
export const SET_ITEMS_KEYS = 'SET_ITEMS_KEYS';
export const SET_ITEMS_TO_SHOW = 'SET_ITEMS_TO_SHOW';
export const SET_PHONEME = 'SET_PHONEME';
export const SET_RANDOM_ITEMS = 'SET_RANDOM_ITEMS';
export const SET_RANDOM_ITEMS_ORDER = 'SET_RANDOM_ITEMS_ORDER';
export const SET_TEST_MODE = 'SET_TEST_MODE';
export const SET_TEST_SENT = 'SET_TEST_SENT';
export const SET_VERSION = 'SET_VERSION';
export const SHOW_FEEDBACK = 'SHOW_FEEDBACK';
export const SHOW_RESULTS = 'SHOW_RESULTS';
export const START_RECORDING = 'START_RECORDING';
export const STOP_RECORDING = 'STOP_RECORDING';
